<template>

    <router-view/>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import { Events as AuthEvents } from 'js-core/js/plugins/Authentication';

@Component({

    name: 'App'
})
export default class App extends Vue
{
    mounted() {

        this.$auth.on(AuthEvents.LOGOUT, this.onLogout.bind(this));
    }

    onLogout(){

        this.logger.warn('Logged out, resetting Apollo store');

        this.$di.apollo.resetStore();
        this.$router.replace({ name: 'login' });
    }
}

</script>